<div >
  <div *ngIf="(information$ | async)"  class="metering-point-item__functioncontrol-wrapper">
    <div>
      <h2 class="h3">{{ (information$ | async).title }}</h2>
    </div>
    <div appRouterLink [innerHTML]="(information$ | async).content" >
    </div>
    <div *ngIf="!meteringPoint.hasFunctionControl && isProductAvailable && !containedHasFunctionControls" class="metering-point-item__functioncontrol-button--wrapper"><button class="sx-button sx-button--blue" (click)="goToOrder()" mat-button>{{'metering.item.functioncontrol.order-button'|translate}}</button></div>
  </div>

  <div *ngIf="meteringPoint.hasFunctionControl" class="metering-point-item__functioncontrol-wrapper">
    <div>
      <app-function-control-contract [meteringPoint]="meteringPoint" ></app-function-control-contract>
    </div>

    <div>
      <h2 class="h3">{{'metering.item.functioncontrol.title_performed'|translate}}</h2>
    </div>
    <div>
        <app-function-control-listing [meteringPoint]="meteringPoint"></app-function-control-listing>
    </div>
  </div>
  <div *ngIf="meteringPoint.type === 'LOG' && containedHasFunctionControls" class="metering-point-item__functioncontrol-wrapper">
    <div class="metering-point-item__metering-form">
      <div>

        <div class="metering-point-item__metering-form__label">{{'metering.item.metering.selected-mp'|translate}}</div>
        <mat-form-field class="metering-point-item__metering-form--select">
          <mat-select [value]="selectedMeteringPoint.id" (selectionChange)="subMeteringPointChanged($event)">
            <mat-option [value]="y.id" *ngFor="let y of meteringPoint.containedMeteringPoints">
              <span class="sxh-capitalize">{{y.name}} </span><span class="sxh-text-mp-id">({{y.id}})</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div>
      <app-function-control-contract [meteringPoint]="meteringPoint" [containedMeteringPoint]="selectedMeteringPoint"></app-function-control-contract>
    </div>
    <div>
      <h2 class="h3">{{'metering.item.functioncontrol.title_performed'|translate}}</h2>
    </div>
    <div>
        <app-function-control-listing [meteringPoint]="meteringPoint" [containedMeteringPoint]="selectedMeteringPoint"></app-function-control-listing>
    </div>
  </div>
</div>
